export default __webpack_public_path__ + "static/media/Caps_coolnets.cb9a6867.jpg";